import { toast } from 'react-toastify';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
    GetPayrollPolicyGroup, UpdatePayrollPolicyGroup
} from "../../../../../../../../reduxToolkit/PayrollPolicy/PayrollPolicyApi";
import {errorMsg} from "../../../../../../../../Apis/functions";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

const UpdatePolicyGroupApp = ({
    t,
    item,
    setItem,
    rule,
    setRule,
    departments,
    setDepartments,
    setEmptyFields,
    setRuleEmptyFields
  }) => {
    const location = useLocation();
    const state = location.state;
    const groupId = state?.groupId ?? null;
    const dispatch = useDispatch();

    /**
     * Loads the existing policy on mount using the id from navigation state.
     */
    useEffect(() => {
        if (groupId) getPolicyGroupById(groupId);
    }, []);

    const getPolicyGroupById = (groupId) => {
        dispatch(GetPayrollPolicyGroup(groupId)).then(({ payload: { data: { data, code, success } } }) => {
            if (success === true) {
                setItem(item.set(data));
                setDepartments(item.setDepartments({ departments: data?.departments }));
            } else {
                errorMsg(code);
            }
        });
    };

    /**
     * Validates the form and dispatches the update request. Shows a warning toast if validation fails.
     */
    const handleUpdate = () => {
        if (!item.isValid({ departments })) {
            setEmptyFields(true);
            if(item?.rules.length === 0) setRuleEmptyFields(true);
            toast.warning(t('please_fill_all_fields'));
            return;
        }

        dispatch(UpdatePayrollPolicyGroup(item.toRegister({ departments }))).then(
            ({ payload: { data: { success, code } } }) => {
                if (success === true) {
                    toast.success(t('has_been_updated_successfully'));
                    getPolicyGroupById(groupId);
                    setRule(rule.clear());
                } else {
                    errorMsg(code);
                }
            }
        );
    };


    return {
        handleUpdate,
    };
};

export default UpdatePolicyGroupApp;
